import Vue from "vue";
import Vuex from "vuex";

import auth from "./module/auth";
import notification from "./module/notification";
import settings from "./module/settings";
import store from "./module/store";
import targetSettings from "./module/targetSettings";
import members from "./module/members";
import head from "./module/head";

Vue.use(Vuex);

const vx = new Vuex.Store({
  modules: {
    auth,
    notification,
    settings,
    store,
    targetSettings,
    members,
    head,
  },
});
global.vx = vx;
export default vx;
